export function getHashPath() {
    const path = window.location.hash.replace('#', '');
    return path.length > 0 ? path : null;
}

export function getPathnameWithSearch() {
    return `${window.location.pathname}${window.location.search}`;
}

export function redirectTo(url) {
    window.location.href = url;
}

export function getHistoryState() {
    return window.history.state;
}

export function pushState(state, url) {
    window.history.pushState(state, '', url);
}

export function replaceState(state, url) {
    window.history.replaceState(state, '', url);
}

export function getScrollY() {
    return window.scrollY;
}

export function scrollToY(y) {
    window.scrollTo(0, y);
}

// Returns the teardown, so callers that outlive a page can unsubscribe.
export function onWindow(type, handler) {
    window.addEventListener(type, handler);
    return () => window.removeEventListener(type, handler);
}
